// Uploaded brand assets
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_playfolio-scout/artifacts/b9oljmky_ChatGPT%20Image%20Jul%207%2C%202026%2C%2010_03_42%20PM.png";

export const HERO_BG_URL =
  "https://customer-assets.emergentagent.com/job_playfolio-scout/artifacts/v4wps8l1_ChatGPT%20Image%20Jul%207%2C%202026%2C%2010_32_42%20PM.png";

export const VIDEO_GUIDE_URL =
  "https://customer-assets.emergentagent.com/job_playfolio-scout/artifacts/woxaznyk_ChatGPT%20Image%20Jul%208%2C%202026%2C%2011_10_07%20PM.png";
